export default function useWithdraw() {
  const en = ['WITHDRAW', 'RETURN', 'BROKEN'];
  const th = ['เบิกใช้', 'คืนคลัง', 'เสียหาย'];
  function translateType(string: string) {
    const index = en.indexOf(string);
    if (index > -1) return th[index];
    return '';
  }

  const enStatus = ['PENDING', 'CANCELLED', 'DONE'];
  const thStatus = ['รอดำเนินการ', 'ยกเลิก', 'เสร็จสิ้น'];

  function translateStatus(string: string) {
    const index = enStatus.indexOf(string);
    if (index > -1) return thStatus[index];
    return '';
  }

  const typeClassMap = (type: string) => {
    switch (type) {
      case 'WITHDRAW':
        return 'block w-20 text-white rounded-xl text-xs py-1 text-center bg-green-600';
      case 'RETURN':
        return 'block w-20 text-white rounded-xl text-xs py-1 text-center bg-primary-600';
      case 'BROKEN':
        return 'block w-20 text-white rounded-xl text-xs py-1 text-center bg-red-600';
      default: return '';
    }
  };

  const statusClassMap = (status: string) => {
    switch (status) {
      case 'PENDING':
        return 'block w-22 text-white rounded-xl text-xs py-1 text-center bg-orange-500';
      case 'CANCELLED':
        return 'block w-20 text-white rounded-xl text-xs py-1 text-center bg-gray-600';
      case 'DONE':
        return 'block w-20 text-white rounded-xl text-xs py-1 text-center bg-green-500';
      default: return '';
    }
  };

  return {
    en,
    th,
    enStatus,
    thStatus,
    typeClassMap,
    translateType,
    translateStatus,
    statusClassMap,
  };
}
